import { postToPos24Api } from './pos24ApiService';

export function addOrderToOkc(ticket, callback, failCallback) {
    postToPos24Api('/api/Okc/AddInposTsmOrder', ticket, callback, failCallback);
}


// WEBPACK FOOTER //
// ./app/services/okcService.js